import { setter } from './utils';
import { LOADED_PDF } from '../actions/types';

export default setter(LOADED_PDF, null);
